import {
  GET_MODA_INVOICE_UPDATE_REQUEST,
  GET_MODA_INVOICE_UPDATE_SUCCESS,
  GET_MODA_INVOICE_UPDATE_ERROR,
  UPDATE_MODA_INVOICE_UPDATE_REQUEST,
  UPDATE_MODA_INVOICE_UPDATE_SUCCESS,
  UPDATE_MODA_INVOICE_UPDATE_ERROR,

} from "../actions/types";

export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_MODA_INVOICE_UPDATE_REQUEST:
      return {
        loading: true,
      };
    case GET_MODA_INVOICE_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_MODA_INVOICE_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_MODA_INVOICE_UPDATE_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_MODA_INVOICE_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case UPDATE_MODA_INVOICE_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
      };

      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
